"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.5075 6c.27 0 .5175-.06.735-.1725.2475-.1275.435-.315.57-.5475C14.94 5.0475 15 4.785 15 4.5c0-.4425-.15-.8175-.42-1.0875-.2775-.27-.6525-.4125-1.0875-.4125-.27 0-.5175.06-.7425.18-.2325.1275-.42.3075-.555.5475-.1275.2175-.195.48-.195.7725 0 .4425.15.8175.4275 1.0875.27.27.645.4125 1.08.4125zM9 20.5c0 .8284-.6716 1.5-1.5 1.5S6 21.3284 6 20.5 6.6716 19 7.5 19s1.5.6716 1.5 1.5zm9 0c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5zM10 14v-.27l-2 .91V16h10v2H6V7h2v5.45l2-.91V11c0-.55.45-1 1-1h1V9h-2c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1v1.27l2.58-1.18.83 1.82L12 12.83V14c0 .55-.45 1-1 1s-1-.45-1-1z"
  })];
};

exports.default = _default;